"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isMtop;

function isMtop() {
  var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return /^mtop\./.test(api);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9taXNlcy9pc010b3AudHMiXSwibmFtZXMiOlsiaXNNdG9wIiwiYXBpIiwidGVzdCJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFlLFNBQVNBLE1BQVQsR0FBMEI7QUFBQSxNQUFWQyxHQUFVLHVFQUFKLEVBQUk7QUFDckMsU0FBTyxVQUFVQyxJQUFWLENBQWVELEdBQWYsQ0FBUDtBQUNIIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gaXNNdG9wKGFwaSA9ICcnKSB7XG4gICAgcmV0dXJuIC9ebXRvcFxcLi8udGVzdChhcGkpO1xufVxuIl19